import * as types from '../const/action.types';

export function list(state = [], action) {
    switch (action.type) {
        case types.LOAD_LIST_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function listsHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.LISTS_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function listsIsLoading(state = false, action) {
    switch (action.type) {
        case types.LISTS_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/list.reducer.js